<template>
    <div v-if="!isMobile" class="mt-3" style="border: 1px solid #228FEF; background-color: #E9F5FF; border-radius: 5px; font-size: 12px; text-align: center; padding: 5px 80px 5px 80px;">
        <div>Na etapa de pagamento você pode efetuar apenas {{$props.porcentagemParcial}}% ({{ totalPagamentoParcial }}) do valor para garantir sua reserva</div>
    </div>
    <div v-else class="px-3 py-2" style="background-color: #E9F5FF; font-size: 12px; color: #425D75; text-align: left;">
        <div><strong>Na etapa de pagamento você pode efetuar apenas {{$props.porcentagemParcial}}% ({{ totalPagamentoParcial }}) do valor para garantir sua reserva</strong></div>
    </div>
</template>
<script>
export default {
    props: {
        precoParcialLabel: {
            type: String,
            default: () => 0,
            required: false
        },
        porcentagemParcial: {
            type: Number,
            default: () => 0,
            required: false
        },
        total: {
            type: Number,
            default: () => 0,
            required: true
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false
        }
    },
    data() {
        return {}
    },
    computed: {
        totalPagamentoParcial(){
            if (this.$props.total == 0) {
                return this.$props.precoParcialLabel
            }
            return this.formatMoney((this.$props.total * this.$props.porcentagemParcial) / 100);
        }
    },
    methods:{
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.$props.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return Number(0.00).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
            }
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
        },
    }
}
</script>